<template>
    <div class="my-10">
        <div class="flex w-full gap-10">
            <div class="w-full flex flex-col gap-5 divide-y ">
                <div v-for="cart in getFoodCart?.orders" :key="cart.id" class="border-solid border border-[#aaaaaa] rounded-lg p-5 gap-10 ">
                    <div class="flex flex-col gap-5">

                        <p class="text-2xl font-bold">{{ cart?.store?.name }}</p>
                        <div>
                            <p class="">{{ $t('page.location') }}: {{ cart?.store?.location }}</p>
                            <div class="flex gap-1 " v-if="cart?.store?.work_hours"><p>{{ $t('page.workTime') }}: </p> {{ cart?.store?.work_hours[getDay(cart?.store?.work_hours).toLowerCase()] }} </div>
                        </div>
                        <div class=" grid grid-cols-2 gap-3 max-lg:grid-cols-1">
                            <div class="flex flex-col gap-5">
                                <FoodCartCard v-for="item in cart.cart_items" :key="item.id" :detail="item"></FoodCartCard>

                            </div>

                            <div class="divide-y flex flex-col bg-white rounded h-max">
                                <div class="p-5 flex justify-center">
                                    <p class="text-2xl text-main-color font-bold">{{ $t('nav.checkout') }}</p>
                                </div>
                                <div class="p-5">
                                    <div class="flex justify-between mb-5">

                                        <div class="flex flex-col gap-5">
                                            <p class="text-lg font-light text-main-color">{{ $t('page.overallPrice') }}</p>
                                        </div>
                                        <div class="flex flex-col gap-5">
                                            <p class="text-lg font-light text-main-color">{{ formatNumber(cart.price) }} TMT</p>
                                        </div>
                                    </div>
                                    <p class="mb-2 text-red-500"><span class="text-red-500">*</span>{{ $t('page.delivery_note') }}</p>
                                        <p v-if="cart?.store?.min_delivery_price" class="mb-4 text-red-500">{{ $t('page.min_order_plain', { price: cart?.store?.min_delivery_price }) }}</p>
                                    <router-link :to="cart.price < cart?.store?.min_delivery_price ? '#' : { name: 'foodCheckout', params: { id: cart.id } }" class="w-full block text-center rounded text-white bg-main-color py-4 text-base font-bold" :class="{'opacity-80' : cart.price < cart?.store?.min_delivery_price}">{{ $t('page.completeCheckout') }}</router-link>
                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-96" v-show="getFoodCart?.orders?.length <= 0">
                    {{ $t('page.cartIsEmpty') }}
                </div>
            </div>
          
        </div>
    </div>
</template>

<script>
import FoodCartCard from '@cmp/food/FoodCartCard.vue'
import { mapState } from 'pinia'
import { useAppStore } from '@/store'
import { formatNumber, getDay } from '@/helpers'

export default {
    name: 'foodCart',

    components: {
        FoodCartCard
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        getDay,
        formatNumber
    },
    computed: {
        ...mapState(useAppStore, ['getFoodCart']),
    },
    created() {

    }
}

</script>